import { render, staticRenderFns } from "./BusinessMemberPrescriptionCreatePlan.vue?vue&type=template&id=703d6800"
import script from "./BusinessMemberPrescriptionCreatePlan.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptionCreatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports